/**
 * The email and password a sign-in form holds now, read from its fields (named `email` and
 * `password`), or null when one is empty. Browsers fill in a saved password on page load but tell
 * the page only once the user interacts, so the page's state can still be empty while the fields
 * look filled: sign-in buttons therefore stay enabled and the form is read on submit.
 */
export function credentialsFrom(form: HTMLFormElement): { email: string; password: string } | null {
  const data = new FormData(form);
  const email = String(data.get('email') ?? '').trim();
  const password = String(data.get('password') ?? '');
  return email && password ? { email, password } : null;
}
